"use strict";
// Copyright (c) Microsoft Corporation.
// Licensed under the MIT license.
Object.defineProperty(exports, "__esModule", { value: true });
exports.TraversalStatus = void 0;
/* eslint-disable no-unused-vars */
// Indicates the status of traversing a descendant hierarchy.
var TraversalStatus;
(function (TraversalStatus) {
    // No traversal at this point in the hierarchy has begun.
    TraversalStatus[TraversalStatus["NotStarted"] = 0] = "NotStarted";
    // A traversal at this point in the hierarchy is in progress.
    TraversalStatus[TraversalStatus["InProgress"] = 1] = "InProgress";
    // The hierarchy hereunder has been fully traversed.
    TraversalStatus[TraversalStatus["Complete"] = 2] = "Complete";
})(TraversalStatus = exports.TraversalStatus || (exports.TraversalStatus = {}));
//# sourceMappingURL=traversalStatus.js.map